import PropTypes from 'prop-types';
import React from 'react';
import Button from '$partials/ui/button';
import { formatLinkBlockToUrl } from '$utilities/data';

/**
 * @function Ticker
 * @prop {array} messages
 */
const Ticker = ({
    backgroundColour = '#ff00a7',
    id = '',
    tickerItems = []
}) => {
    if (tickerItems.length < 1) {
        return null;
    }

    // Duplicate messages to fill screen
    let displayedMessages = JSON.parse(JSON.stringify(tickerItems));
    while (displayedMessages.length < 4) {
        displayedMessages = displayedMessages.concat(JSON.parse(JSON.stringify(tickerItems)));
    }

    // Duplicate messages to handle overflow repeats
    const duplicateCount = 2;
    let messagesWithRepeats = [];
    for (let i = 0; i < duplicateCount; i++) {
        messagesWithRepeats = messagesWithRepeats.concat(JSON.parse(JSON.stringify(displayedMessages)));
    }

    const itemMinWidth = Math.max(100 / displayedMessages.length, 25);

    return (
        <div
            className='col-span-3 sm:col-span-5 md:col-span-7 lg:col-span-9 overflow-hidden py-30 mb-1'
            style={{ backgroundColor: backgroundColour }}>
            <style dangerouslySetInnerHTML={{__html: `
                .ticker-${id} {
                    animation-duration: ${(displayedMessages.length * itemMinWidth) * 1}s;
                }
            `}} />
            <ul className={`ticker ticker-${id} list-reset bg-white`}>
                {messagesWithRepeats?.map((message, i) => {
                    return (
                        <li
                            className={`mx-45 ticker__item ticker__item-${id} inline-block`}
                            key={i}>
                            {message?.h1Text ? (
                                <p
                                    className='type-style-hero-sm'
                                    style={{color: `${message?.h1TextColour}`}}>
                                    {message?.h1Text}
                                </p>
                            ) : message?.ctaLabel && message?.ctaLink ? (
                                <Button
                                    as='a'
                                    className='block h-[48px] leading-[48px] px-[30px] rounded-[24px] bg-[#000] text-[#fff]'
                                    href={formatLinkBlockToUrl(message?.ctaLink)}>
                                    {message?.ctaLabel}
                                </Button>
                            ) : null}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

Ticker.propTypes = {
    backgroundColour: PropTypes.string,
    id: PropTypes.string,
    tickerItems: PropTypes.array
};

export default Ticker;
